/**
 * The router: TanStack Router over `routeTree`, preloading routes on intent
 * (hover, focus, touch start), with page changes cross-faded through
 * `viewTransition()` (which honours reduced motion).
 */
import { createRouter } from '@tanstack/react-router';

import { viewTransition } from '../ui/motion.js';
import { routeTree } from './routes.js';

/** Creates the router. */
export function createAppRouter() {
  const router = createRouter({
    routeTree,
    defaultPreload: 'intent',
    // Data freshness belongs to TanStack Query, not the router's cache.
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
  });
  // Route the router's view transitions through the shared helper, so page
  // changes, language switches and reduced motion all behave the same way.
  router.startViewTransition = (fn) => viewTransition(fn);
  return router;
}

/** The app's router type. */
export type AppRouter = ReturnType<typeof createAppRouter>;
